import { Component, OnInit } from '@angular/core';
import { ReporteDinamicoService } from '../reporte-dinamico.service';
import { LoginService } from '../../../login/login.service';
//Ahora necesito el jsPdf para generar el pdf
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import * as XLSX from 'xlsx';
import { PeriodoEjercicioService } from '../../../control/periodo.service';
@Component({
  selector: 'app-ctb-balance-general-din',
  templateUrl: './ctb-balance-general-din.component.html',
  styleUrls: ['./ctb-balance-general-din.component.css'],
    providers: [ReporteDinamicoService]
})
export class CtbBalanceGeneralDinComponent implements OnInit {


  public busqueda: any = {
    _gral_emp_id: 0,
    _year: 0,
    _month: 0
  };
  private empresa_info_actual: any;
  public ejercicios: any[] = [];
balanceData: BalanceData = {
  saldo: {
    saldo: 0,
    utilidad: false
  },
  activo: [],
  pasivo: [],
  capital: []
};  groupedActivo: any[] = [];
  groupedPasivo: any[] = [];
  groupedCapital: any[] = [];
  constructor(private reporteDinamicoService: ReporteDinamicoService, private loginService: LoginService, private PeriodoEjercicioService: PeriodoEjercicioService) { 
  }

  ngOnInit(): void {
    this.empresa_info_actual = this.loginService.empresa_info_actual;
    this.ejercicios = this.loginService.ejercicios;
    this.busqueda._gral_emp_id = this.loginService.empresa;
     this.PeriodoEjercicioService.ejercicio$.subscribe(ejercicio => {
      this.busqueda._year = ejercicio ? ejercicio : 0;

    });
    this.PeriodoEjercicioService.periodo$
      .subscribe(periodo => {

        this.busqueda._month = periodo ? periodo : 13;
      });
    this.cargarReporte();
  }


  cargarReporte() {
    console.log('Cargando reporte para:', this.busqueda);
    // Lógica para cargar el reporte basado en this.busqueda
    this.reporteDinamicoService.ctb_reporte_balance_general_din(this.busqueda._year, this.busqueda._month, this.busqueda._gral_emp_id).
    subscribe(data => {
      console.log('Datos del reporte:', data);
      this.balanceData = data.data;
      this.groupedActivo = this.groupItemsByLevel(this.balanceData.activo);
      this.groupedPasivo = this.groupItemsByLevel(this.balanceData.pasivo);
      this.groupedCapital = this.groupItemsByLevel(this.balanceData.capital);

    });

  }
  groupItemsByLevel(items: BalanceItem[]): any[] {
    const grouped: any[] = [];
    let currentGroup: { children: any; parent?: BalanceItem; } | null = null;

    items.forEach(item => {
      if (item.bg_nivel === 1) {
        if (currentGroup) grouped.push(currentGroup);
        currentGroup = {
          parent: item,
          children: []
        };
      } else {
        currentGroup?.children.push(item);
      }
    });

    if (currentGroup) grouped.push(currentGroup);
    return grouped;
  }
  exportAsXLSX() {
    console.log('Exportando como XLSX para:', this.busqueda);
    // Lógica para exportar el reporte como XLSX
  
    const fecha = new Date();
    const fechaStr = fecha.toLocaleDateString('es-MX').replace(/\//g, '-');
    const horaStr = fecha.toLocaleTimeString('es-MX', { hour: '2-digit', minute: '2-digit' }).replace(/:/g, '-');
    
    // Crear un nuevo libro de trabajo
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    
    // Hoja de RESUMEN
    this.crearHojaResumen(wb, fecha, fechaStr, horaStr);
    
    // Hoja de ACTIVO
    this.crearHojaActivo(wb);
    
    // Hoja de PASIVO
    this.crearHojaPasivo(wb);
    
    // Hoja de CAPITAL
    this.crearHojaCapital(wb);
    
    // Hoja de DETALLE COMPLETO
    this.crearHojaDetalleCompleto(wb);
    
    // Hoja de ECUACIÓN CONTABLE
    this.crearHojaEcuacionContable(wb);
    
    // Generar y descargar el archivo Excel
    const nombreArchivo = this.empresa_info_actual.titulo.toLowerCase().replace(/\s+/g, '_') + `_balance_general_${fechaStr}_${horaStr}.xlsx`;
    XLSX.writeFile(wb, nombreArchivo);
  }

  private crearHojaResumen(wb: XLSX.WorkBook, fecha: Date, fechaStr: string, horaStr: string) {
    const resumenData = [
      ['REPORTE DE BALANCE GENERAL A ' + this.busqueda._year +' ' + this.busqueda._month, '', '', '', ''],
      ['', '', '', '', ''],
      ['Fecha:', fechaStr, 'Hora:', horaStr, ''],
      ['Empresa:', this.empresa_info_actual.titulo, 'RFC: ' +this.empresa_info_actual.rfc, '', ''],
      ['', '', '', '', ''],
      ['RESUMEN DEL BALANCE GENERAL', '', '', '', ''],
      ['', '', '', '', ''],
      ['CONCEPTO', 'VALOR', 'ESTADO', '', ''],
      ['Saldo Total Según Estado de Resultados', this.balanceData.saldo.saldo, this.balanceData.saldo.utilidad ? 'UTILIDAD' : 'PÉRDIDA', '', ''],
      ['', '', '', '', ''],
      ['DISTRIBUCIÓN POR SECCIÓN', '', '', '', ''],
      ['SECCIÓN', 'TOTAL', 'PORCENTAJE', '', ''],
    ];

    const totalActivo = this.getTotalActivo();
    const totalPasivo = this.getTotalPasivo();
    const totalCapital = this.getTotalCapital();
    const totalGeneral = totalActivo + totalPasivo + totalCapital;

    resumenData.push(
      ['ACTIVO', totalActivo, totalGeneral > 0 ? (totalActivo / totalGeneral * 100).toFixed(2) + '%' : '0%', '', ''],
      ['PASIVO', totalPasivo, totalGeneral > 0 ? (totalPasivo / totalGeneral * 100).toFixed(2) + '%' : '0%', '', ''],
      ['CAPITAL CONTABLE', totalCapital, totalGeneral > 0 ? (totalCapital / totalGeneral * 100).toFixed(2) + '%' : '0%', '', ''],
      ['', '', '', '', ''],
      ['ECUACIÓN CONTABLE', '', '', '', ''],
      ['ACTIVO', '=', 'PASIVO', '+', 'CAPITAL CONTABLE'],
      [totalActivo, '=', totalPasivo, '+', totalCapital],
      ['', '', '', '', ''],
      ['VERIFICACIÓN', '', '', '', ''],
      ['Diferencia:', Math.abs(totalActivo - (totalPasivo + totalCapital)), '', '', ''],
      ['Estado:', Math.abs(totalActivo - (totalPasivo + totalCapital)) < 0.01 ? 'BALANCEADO' : 'DESBALANCEADO', '', '', '']
    );

    const ws: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(resumenData);

    // Aplicar estilos y formatos
    this.aplicarEstilosResumen(ws, resumenData.length);

    // Agregar la hoja al libro
    XLSX.utils.book_append_sheet(wb, ws, 'RESUMEN');
  }

  private aplicarEstilosResumen(ws: XLSX.WorkSheet, filas: number) {
    // Definir rangos para formato
    const range = { s: { r: 0, c: 0 }, e: { r: filas - 1, c: 4 } };
    
    // Título principal
    ws['!merges'] = [
      { s: { r: 0, c: 0 }, e: { r: 0, c: 4 } }, // Título
      { s: { r: 2, c: 1 }, e: { r: 2, c: 1 } }, // Fecha
      { s: { r: 2, c: 3 }, e: { r: 2, c: 3 } }, // Hora
      { s: { r: 5, c: 0 }, e: { r: 5, c: 4 } }, // Sección RESUMEN
      { s: { r: 10, c: 0 }, e: { r: 10, c: 4 } }, // Sección DISTRIBUCIÓN
      { s: { r: 15, c: 0 }, e: { r: 15, c: 4 } }, // Sección ECUACIÓN
      { s: { r: 20, c: 0 }, e: { r: 20, c: 4 } }, // Sección VERIFICACIÓN
    ];

    // Aplicar estilos a celdas específicas
    const styles: { [key: string]: any } = {
      // Título principal
      'A1': { s: { font: { bold: true, sz: 16 }, alignment: { horizontal: 'center' } } },
      
      // Encabezados de secciones
      'A6': { s: { font: { bold: true, sz: 14 }, fill: { fgColor: { rgb: "4F81BD" } } } },
      'A11': { s: { font: { bold: true, sz: 12 }, fill: { fgColor: { rgb: "C5D9F1" } } } },
      'A16': { s: { font: { bold: true, sz: 12 }, fill: { fgColor: { rgb: "E6B8B7" } } } },
      'A21': { s: { font: { bold: true, sz: 12 }, fill: { fgColor: { rgb: "C5E0B4" } } } },
      
      // Encabezados de tabla
      'A8': { s: { font: { bold: true }, fill: { fgColor: { rgb: "D9E1F2" } } } },
      'B8': { s: { font: { bold: true }, fill: { fgColor: { rgb: "D9E1F2" } } } },
      'C8': { s: { font: { bold: true }, fill: { fgColor: { rgb: "D9E1F2" } } } },
      
      'A12': { s: { font: { bold: true }, fill: { fgColor: { rgb: "B4C6E7" } } } },
      'B12': { s: { font: { bold: true }, fill: { fgColor: { rgb: "B4C6E7" } } } },
      'C12': { s: { font: { bold: true }, fill: { fgColor: { rgb: "B4C6E7" } } } },
      
      // Saldo Total
      'B9': { s: { numFmt: '"$"#,##0.00' } },
      
      // Totales por sección
      'B13': { s: { numFmt: '"$"#,##0.00', font: { bold: true } } },
      'B14': { s: { numFmt: '"$"#,##0.00', font: { bold: true } } },
      'B15': { s: { numFmt: '"$"#,##0.00', font: { bold: true } } },
      
      // Ecuación contable
      'A17': { s: { font: { bold: true, sz: 14 }, alignment: { horizontal: 'center' } } },
      'A18': { s: { font: { bold: true, sz: 12 }, alignment: { horizontal: 'center' } } },
      'B18': { s: { font: { bold: true, sz: 12 }, alignment: { horizontal: 'center' } } },
      'C18': { s: { font: { bold: true, sz: 12 }, alignment: { horizontal: 'center' } } },
      'D18': { s: { font: { bold: true, sz: 12 }, alignment: { horizontal: 'center' } } },
      'E18': { s: { font: { bold: true, sz: 12 }, alignment: { horizontal: 'center' } } },
      
      'A19': { s: { numFmt: '"$"#,##0.00', font: { bold: true }, alignment: { horizontal: 'center' } } },
      'B19': { s: { font: { bold: true }, alignment: { horizontal: 'center' } } },
      'C19': { s: { numFmt: '"$"#,##0.00', font: { bold: true }, alignment: { horizontal: 'center' } } },
      'D19': { s: { font: { bold: true }, alignment: { horizontal: 'center' } } },
      'E19': { s: { numFmt: '"$"#,##0.00', font: { bold: true }, alignment: { horizontal: 'center' } } },
      
      // Verificación
      'B22': { s: { numFmt: '"$"#,##0.00', font: { bold: true, color: { rgb: Math.abs(this.getTotalActivo() - (this.getTotalPasivo() + this.getTotalCapital())) < 0.01 ? "007F00" : "FF0000" } } } },
      'B23': { s: { font: { bold: true, color: { rgb: Math.abs(this.getTotalActivo() - (this.getTotalPasivo() + this.getTotalCapital())) < 0.01 ? "007F00" : "FF0000" } } } },
    };

    // Aplicar estilos
    Object.keys(styles).forEach(cell => {
      if (!ws[cell]) ws[cell] = {};
      ws[cell].s = styles[cell].s;
    });

    // Ajustar anchos de columna
    ws['!cols'] = [
      { wch: 30 }, // Columna A
      { wch: 20 }, // Columna B
      { wch: 20 }, // Columna C
      { wch: 15 }, // Columna D
      { wch: 25 }  // Columna E
    ];
  }

  private crearHojaActivo(wb: XLSX.WorkBook) {
    const activoData = [
      ['ACTIVO - DETALLE DE CUENTAS', '', '', '', '', '', '', ''],
      ['', '', '', '', '', '', '', ''],
      ['CÓDIGO', 'NOMBRE DE LA CUENTA', 'SALDO FINAL', 'OBSERVACIONES']
    ];

    this.balanceData.activo.forEach(item => {
      console.log(item);
      const saldoInicial = item.bg_saldo_ini;
      const netoMensual = item.bg_mov_mens;
      const saldoFinal = item.bg_saldo_fin;
      
      const nivel = item.bg_nivel;
      const nombre = nivel === 1 ? item.bg_nombre.toUpperCase() : `  ${item.bg_nombre}`;
      const codigo = nivel === 1 ? item.bg_cuenta : `  ${item.bg_cuenta}`;

      activoData.push([
        codigo,
        nombre,
        saldoFinal+ '',
        ''
      ]);
    });

    // Agregar totales
    const totalSaldoInicial = this.balanceData.activo.reduce((sum, item) => sum + item.bg_saldo_ini, 0);
    const totalCargoMens = this.balanceData.activo.reduce((sum, item) => sum + item.bg_mov_mens, 0);
    const totalAbonoMens = this.balanceData.activo.reduce((sum, item) => sum + 0, 0);
    const totalNetoMens = totalCargoMens - totalAbonoMens;
    const totalSaldoFinal = this.getTotalActivo();

    activoData.push(['', '', '', '', '', '', '', '']);
    activoData.push([
      '',
      'TOTAL ACTIVO',
      totalSaldoFinal+ '',
      ''
    ]);

    const ws: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(activoData);
    
    // Aplicar estilos
    this.aplicarEstilosTabla(ws, activoData.length, 8, '4F81BD');
    
    // Ajustar anchos de columna
    ws['!cols'] = [
      { wch: 15 }, // Código
      { wch: 40 }, // Nombre
      { wch: 18 }, // Saldo Final
      { wch: 25 }  // Observaciones
    ];

    XLSX.utils.book_append_sheet(wb, ws, 'ACTIVO');
  }

  private crearHojaPasivo(wb: XLSX.WorkBook) {
    const pasivoData = [
      ['PASIVO - DETALLE DE CUENTAS', '', '', '', '', '', '', ''],
      ['', '', '', '', '', '', '', ''],
      ['CÓDIGO', 'NOMBRE DE LA CUENTA', 'SALDO FINAL', 'OBSERVACIONES']
    ];

    this.balanceData.pasivo.forEach(item => {
      const saldoInicial = item.bg_saldo_ini;
      const netoMensual = item.bg_mov_mens;
      const saldoFinal = item.bg_saldo_fin;

      const nivel = item.bg_nivel;
      const nombre = nivel === 1 ? item.bg_nombre.toUpperCase() : `  ${item.bg_nombre}`;
      const codigo = nivel === 1 ? item.bg_cuenta : `  ${item.bg_cuenta}`;

      pasivoData.push([
        codigo,
        nombre,
        saldoFinal+ '',
        ''
      ]);
    });

    // Agregar totales
    const totalSaldoInicial = this.balanceData.pasivo.reduce((sum, item) => sum + item.bg_saldo_ini, 0);
    const totalSaldoMens = this.balanceData.pasivo.reduce((sum, item) => sum + item.bg_mov_mens, 0);
    const totalNetoMens = totalSaldoMens - 0;
    const totalSaldoFinal = this.getTotalPasivo();

    pasivoData.push(['', '', '', '', '', '', '', '']);
    pasivoData.push([
      '',
      'TOTAL PASIVO',
      totalSaldoFinal+ '',
      ''
    ]);

    const ws: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(pasivoData);
    
    // Aplicar estilos
    this.aplicarEstilosTabla(ws, pasivoData.length, 8, 'C65911');
    
    // Ajustar anchos de columna
    ws['!cols'] = [
      { wch: 15 }, // Código
      { wch: 40 }, // Nombre
      { wch: 18 }, // Saldo Final
      { wch: 25 }  // Observaciones
    ];

    XLSX.utils.book_append_sheet(wb, ws, 'PASIVO');
  }

  private crearHojaCapital(wb: XLSX.WorkBook) {
    const capitalData = [
      ['CAPITAL CONTABLE - DETALLE DE CUENTAS', '', '', '', '', '', '', ''],
      ['', '', '', '', '', '', '', ''],
      ['CÓDIGO', 'NOMBRE DE LA CUENTA', 'SALDO FINAL', 'OBSERVACIONES']
    ];

    this.balanceData.capital.forEach(item => {
      const saldoInicial = item.bg_saldo_ini;
      const netoMensual = item.bg_mov_mens;
      const saldoFinal = item.bg_saldo_fin;

      const nivel = item.bg_nivel;
      const nombre = nivel === 1 ? item.bg_nombre.toUpperCase() : `  ${item.bg_nombre}`;
      const codigo = nivel === 1 ? item.bg_cuenta : `  ${item.bg_cuenta}`;

      capitalData.push([
        codigo,
        nombre,
        saldoFinal+ '',
        ''
      ]);
    });

    // Agregar totales
    const totalSaldoInicial = this.balanceData.capital.reduce((sum, item) => sum + item.bg_saldo_ini, 0);
    
    const totalNetoMens = this.balanceData.capital.reduce((sum, item) => sum + item.bg_mov_mens, 0);
    const totalSaldoFinal = this.getTotalCapital();

    capitalData.push(['', '', '', '', '', '', '', '']);
    capitalData.push([
      '',
      'TOTAL CAPITAL CONTABLE',
      totalSaldoFinal+ '',
      ''
    ]);

    const ws: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(capitalData);
    
    // Aplicar estilos
    this.aplicarEstilosTabla(ws, capitalData.length, 8, '378E3B');
    
    // Ajustar anchos de columna
    ws['!cols'] = [
      { wch: 15 }, // Código
      { wch: 40 }, // Nombre
      { wch: 18 }, // Saldo Final
      { wch: 25 }  // Observaciones
    ];

    XLSX.utils.book_append_sheet(wb, ws, 'CAPITAL');
  }

  private crearHojaDetalleCompleto(wb: XLSX.WorkBook) {
    const detalleData = [
      ['DETALLE COMPLETO - BALANCE GENERAL', '', '', '', '', '', '', ''],
      ['', '', '', '', '', '', '', ''],
      ['SECCIÓN', 'NIVEL', 'CÓDIGO', 'NOMBRE DE LA CUENTA', 'SALDO INICIAL', 'CARGO MENSUAL', 'ABONO MENSUAL', 'SALDO FINAL']
    ];

    // Agregar ACTIVO
    this.balanceData.activo.forEach(item => {
      detalleData.push([
        'ACTIVO',
        item.bg_nivel+ '',
        item.bg_cuenta,
        item.bg_nombre,
        item.bg_saldo_ini+ '',
         '',
         '',
        (item.bg_saldo_fin)+ ''
      ]);
    });

    detalleData.push(['', '', '', '', '', '', '', '']);

    // Agregar PASIVO
    this.balanceData.pasivo.forEach(item => {
      detalleData.push([
        'PASIVO',
        item.bg_nivel+ '',
        item.bg_cuenta,
        item.bg_nombre,
        item.bg_saldo_ini+ '',
         '',
         '',
        (item.bg_saldo_fin)+ ''
      ]);
    });

    detalleData.push(['', '', '', '', '', '', '', '']);

    // Agregar CAPITAL
    this.balanceData.capital.forEach(item => {
      detalleData.push([
        'CAPITAL',
        item.bg_nivel+ '',
        item.bg_cuenta,
        item.bg_nombre,
        item.bg_saldo_ini+ '',
         '',
         '',
        (item.bg_saldo_fin)+ ''
      ]);
    });

    const ws: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(detalleData);
    
    // Aplicar formatos condicionales visuales
    this.aplicarEstilosDetalleCompleto(ws, detalleData.length);
    
    // Ajustar anchos de columna
    ws['!cols'] = [
      { wch: 10 }, // Sección
      { wch: 8 },  // Nivel
      { wch: 15 }, // Código
      { wch: 40 }, // Nombre
      { wch: 18 }, // Saldo Inicial
      { wch: 15 }, // Cargo Mensual
      { wch: 15 }, // Abono Mensual
      { wch: 18 }  // Saldo Final
    ];

    XLSX.utils.book_append_sheet(wb, ws, 'DETALLE COMPLETO');
  }

  private crearHojaEcuacionContable(wb: XLSX.WorkBook) {
    const totalActivo = this.getTotalActivo();
    const totalPasivo = this.getTotalPasivo();
    const totalCapital = this.getTotalCapital();
    const diferencia = Math.abs(totalActivo - (totalPasivo + totalCapital));
    
    const ecuacionData = [
      ['VERIFICACIÓN DE LA ECUACIÓN CONTABLE', '', '', ''],
      ['', '', '', ''],
      ['ECUACIÓN CONTABLE:', 'ACTIVO', '=', 'PASIVO + CAPITAL CONTABLE'],
      ['', '', '', ''],
      ['VALORES:', totalActivo, '=', `${totalPasivo} + ${totalCapital}`],
      ['', '', '', ''],
      ['CÁLCULO:', '', '', ''],
      ['PASIVO + CAPITAL CONTABLE:', totalPasivo + totalCapital, '', ''],
      ['ACTIVO:', totalActivo, '', ''],
      ['', '', '', ''],
      ['DIFERENCIA:', diferencia, '', ''],
      ['ESTADO:', diferencia < 0.01 ? 'BALANCEADO' : 'DESBALANCEADO', '', ''],
      ['', '', '', ''],
      ['ANÁLISIS:', '', '', ''],
      ['Porcentaje de diferencia:', totalActivo > 0 ? ((diferencia / totalActivo) * 100).toFixed(4) + '%' : '0%', '', ''],
      ['', '', '', ''],
      ['RECOMENDACIONES:', '', '', ''],
      [diferencia < 0.01 ? '✓ La ecuación contable está correctamente balanceada.' : '✗ Existe una diferencia que debe ser investigada.', '', '', ''],
      [diferencia < 0.01 ? 'Puede proceder con el cierre contable.' : 'Verifique las transacciones del período.', '', '', '']
    ];

    const ws: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(ecuacionData);
    
    // Aplicar estilos
    ws['!merges'] = [
      { s: { r: 0, c: 0 }, e: { r: 0, c: 3 } },
      { s: { r: 2, c: 0 }, e: { r: 2, c: 0 } },
      { s: { r: 4, c: 0 }, e: { r: 4, c: 0 } },
      { s: { r: 6, c: 0 }, e: { r: 6, c: 3 } },
      { s: { r: 10, c: 0 }, e: { r: 10, c: 0 } },
      { s: { r: 11, c: 0 }, e: { r: 11, c: 0 } },
      { s: { r: 13, c: 0 }, e: { r: 13, c: 3 } },
      { s: { r: 14, c: 0 }, e: { r: 14, c: 0 } },
      { s: { r: 16, c: 0 }, e: { r: 16, c: 3 } },
      { s: { r: 17, c: 0 }, e: { r: 17, c: 3 } },
      { s: { r: 18, c: 0 }, e: { r: 18, c: 3 } }
    ];

    // Aplicar formatos numéricos
    const formatoMoneda = '"$"#,##0.00';
    ws['B5'].z = formatoMoneda;
    ws['D5'].z = formatoMoneda;
    ws['B8'].z = formatoMoneda;
    ws['B9'].z = formatoMoneda;
    ws['B11'].z = formatoMoneda;
    
    // Estilos
    const estilos: { [key: string]: any } = {
      'A1': { s: { font: { bold: true, sz: 16 }, alignment: { horizontal: 'center' } } },
      'A3': { s: { font: { bold: true, sz: 12 } } },
      'A5': { s: { font: { bold: true, sz: 12 } } },
      'B5': { s: { font: { bold: true, color: { rgb: "0070C0" } } } },
      'D5': { s: { font: { bold: true, color: { rgb: "0070C0" } } } },
      'A7': { s: { font: { bold: true, sz: 12 }, fill: { fgColor: { rgb: "F2F2F2" } } } },
      'B11': { s: { font: { bold: true, color: { rgb: diferencia < 0.01 ? "007F00" : "FF0000" } } } },
      'B12': { s: { font: { bold: true, color: { rgb: diferencia < 0.01 ? "007F00" : "FF0000" } } } },
      'A15': { s: { font: { bold: true } } },
      'A17': { s: { font: { bold: true, sz: 12 } } },
      'A18': { s: { font: { italic: true } } },
      'A19': { s: { font: { italic: true } } }
    };

    Object.keys(estilos).forEach(cell => {
      if (!ws[cell]) ws[cell] = {};
      ws[cell].s = estilos[cell].s;
    });

    // Ajustar anchos
    ws['!cols'] = [
      { wch: 35 },
      { wch: 25 },
      { wch: 10 },
      { wch: 25 }
    ];

    XLSX.utils.book_append_sheet(wb, ws, 'ECUACIÓN CONTABLE');
  }

  private aplicarEstilosTabla(ws: XLSX.WorkSheet, filas: number, columnas: number, colorEncabezado: string) {
    // Título
    ws['!merges'] = [{ s: { r: 0, c: 0 }, e: { r: 0, c: columnas - 1 } }];
    if (!ws['A1']) ws['A1'] = {};
    ws['A1'].s = { font: { bold: true, sz: 14 }, alignment: { horizontal: 'center' }, fill: { fgColor: { rgb: colorEncabezado } } };

    // Encabezados de columna
    const encabezadoRow = 2; // Fila 3 (0-indexed)
    for (let c = 0; c < columnas; c++) {
      const cell = XLSX.utils.encode_cell({ r: encabezadoRow, c });
      if (!ws[cell]) ws[cell] = {};
      ws[cell].s = { 
        font: { bold: true }, 
        fill: { fgColor: { rgb: this.lightenColor(colorEncabezado, 50) } },
        alignment: { horizontal: 'center' }
      };
    }

    // Aplicar formato de moneda a las columnas numéricas
    const formatoMoneda = '"$"#,##0.00';
    for (let r = 3; r < filas; r++) {
      // Columnas C, D, E, F, G (2-6) son numéricas
      for (let c = 2; c <= 6; c++) {
        const cell = XLSX.utils.encode_cell({ r, c });
        if (ws[cell] && typeof ws[cell].v === 'number') {
          ws[cell].z = formatoMoneda;
          
          // Resaltar filas de totales
          if (r === filas - 1) {
            ws[cell].s = { ...ws[cell].s, font: { bold: true }, fill: { fgColor: { rgb: "FFFF00" } } };
          }
        }
      }
      
      // Resaltar nombres de cuentas de nivel 1
      const cellNombre = XLSX.utils.encode_cell({ r, c: 1 });
      if (ws[cellNombre] && ws[cellNombre].v && !ws[cellNombre].v.toString().startsWith('  ')) {
        ws[cellNombre].s = { ...ws[cellNombre].s, font: { bold: true } };
      }
    }

    // Estilo para la fila de totales
    const totalRow = filas - 1;
    for (let c = 0; c < columnas; c++) {
      const cell = XLSX.utils.encode_cell({ r: totalRow, c });
      if (ws[cell]) {
        ws[cell].s = { 
          ...ws[cell].s, 
          font: { bold: true }, 
          fill: { fgColor: { rgb: "FFFF00" } },
          border: {
            top: { style: 'medium', color: { rgb: "000000" } },
            bottom: { style: 'medium', color: { rgb: "000000" } }
          }
        };
      }
    }
  }

  private aplicarEstilosDetalleCompleto(ws: XLSX.WorkSheet, filas: number) {
    // Título
    ws['!merges'] = [{ s: { r: 0, c: 0 }, e: { r: 0, c: 7 } }];
    if (!ws['A1']) ws['A1'] = {};
    ws['A1'].s = { font: { bold: true, sz: 14 }, alignment: { horizontal: 'center' }, fill: { fgColor: { rgb: "7030A0" } } };

    // Encabezados
    for (let c = 0; c < 8; c++) {
      const cell = XLSX.utils.encode_cell({ r: 2, c });
      if (!ws[cell]) ws[cell] = {};
      ws[cell].s = { 
        font: { bold: true }, 
        fill: { fgColor: { rgb: "E4DFEC" } },
        alignment: { horizontal: 'center' }
      };
    }

    // Formato de moneda para columnas numéricas
    const formatoMoneda = '"$"#,##0.00';
    
    // Aplicar colores por sección
    let currentSection = '';
    for (let r = 3; r < filas; r++) {
      const cellSeccion = XLSX.utils.encode_cell({ r, c: 0 });
      const seccion = ws[cellSeccion]?.v;
      
      if (seccion && seccion !== currentSection) {
        currentSection = seccion;
      }
      
      // Color de fondo según la sección
      let colorFondo = '';
      switch (currentSection) {
        case 'ACTIVO': colorFondo = "E6F2FF"; break;
        case 'PASIVO': colorFondo = "FFF2E6"; break;
        case 'CAPITAL': colorFondo = "F0FFE6"; break;
      }
      
      if (colorFondo) {
        for (let c = 0; c < 8; c++) {
          const cell = XLSX.utils.encode_cell({ r, c });
          if (ws[cell]) {
            ws[cell].s = { ...ws[cell].s, fill: { fgColor: { rgb: colorFondo } } };
          }
        }
      }
      
      // Formato numérico
      for (let c = 4; c <= 7; c++) {
        const cell = XLSX.utils.encode_cell({ r, c });
        if (ws[cell] && typeof ws[cell].v === 'number') {
          ws[cell].z = formatoMoneda;
        }
      }
      
      // Negrita para nivel 1
      const cellNivel = XLSX.utils.encode_cell({ r, c: 1 });
      if (ws[cellNivel]?.v === 1) {
        for (let c = 0; c < 8; c++) {
          const cell = XLSX.utils.encode_cell({ r, c });
          if (ws[cell]) {
            ws[cell].s = { ...ws[cell].s, font: { bold: true } };
          }
        }
      }
    }
  }

  private lightenColor(color: string, percent: number): string {
    // Convierte color hexadecimal a RGB
    const num = parseInt(color, 16);
    const amt = Math.round(2.55 * percent);
    const R = (num >> 16) + amt;
    const G = (num >> 8 & 0x00FF) + amt;
    const B = (num & 0x0000FF) + amt;
    
    return (0x1000000 + (R < 255 ? R < 1 ? 0 : R : 255) * 0x10000 +
            (G < 255 ? G < 1 ? 0 : G : 255) * 0x100 +
            (B < 255 ? B < 1 ? 0 : B : 255))
            .toString(16)
            .slice(1);
  }

  // Método para exportar a Excel Compacto (una sola hoja)
  exportarExcelCompacto() {
    const fecha = new Date();
    const fechaStr = fecha.toLocaleDateString('es-MX').replace(/\//g, '-');
    const horaStr = fecha.toLocaleTimeString('es-MX', { hour: '2-digit', minute: '2-digit' }).replace(/:/g, '-');
    
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    
    // Preparar datos combinados
    const data = [
      ['BALANCE GENERAL - RESUMEN COMPACTO', '', '', '', ''],
      ['Fecha:', fechaStr, 'Hora:', horaStr, ''],
      ['', '', '', '', ''],
      ['ACTIVO', '', '', 'PASIVO Y CAPITAL', ''],
      ['Cuenta', 'Descripción', 'Saldo Final', 'Cuenta', 'Descripción', 'Saldo Final']
    ];

    // Determinar el máximo número de filas entre activo y pasivo+capital
    const maxRows = Math.max(
      this.balanceData.activo.length,
      this.balanceData.pasivo.length + this.balanceData.capital.length
    );

    for (let i = 0; i < maxRows; i++) {
      const row = [];
      
      // Columna ACTIVO
      if (i < this.balanceData.activo.length) {
        const item = this.balanceData.activo[i];
        row.push(
          item.bg_cuenta,
          item.bg_nombre,
          item.bg_saldo_fin
        );
      } else {
        row.push('', '', '');
      }
      
      // Columna PASIVO/CAPITAL
      if (i < this.balanceData.pasivo.length) {
        const item = this.balanceData.pasivo[i];
        row.push(
          item.bg_cuenta,
          item.bg_nombre,
          item.bg_saldo_fin
        );
      } else if (i < this.balanceData.pasivo.length + this.balanceData.capital.length) {
        const capitalIndex = i - this.balanceData.pasivo.length;
        const item = this.balanceData.capital[capitalIndex];
        row.push(
          item.bg_cuenta,
          item.bg_nombre,
          item.bg_saldo_fin
        );
      } else {
        row.push('', '', '');
      }
      
      data.push(row);
    }

    // Agregar totales
    data.push(['', '', '', '', '', '']);
    data.push([
      'TOTAL ACTIVO',
      '',
      this.getTotalActivo() + '',
      'TOTAL PASIVO + CAPITAL',
      '',
      (this.getTotalPasivo() + this.getTotalCapital()) + ''
    ]);

    const ws: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(data);
    
    // Aplicar estilos básicos
    ws['!merges'] = [
      { s: { r: 0, c: 0 }, e: { r: 0, c: 5 } },
      { s: { r: 3, c: 0 }, e: { r: 3, c: 2 } },
      { s: { r: 3, c: 3 }, e: { r: 3, c: 5 } }
    ];

    // Ajustar anchos
    ws['!cols'] = [
      { wch: 15 },
      { wch: 35 },
      { wch: 18 },
      { wch: 15 },
      { wch: 35 },
      { wch: 18 }
    ];

    XLSX.utils.book_append_sheet(wb, ws, 'Balance General');
    XLSX.writeFile(wb, `Balance_Compacto_${fechaStr}_${horaStr}.xlsx`);
  }

  // Método para exportar a CSV (si se necesita)
  exportarCSV() {
    const fecha = new Date().toLocaleDateString('es-MX').replace(/\//g, '-');
    
    // Preparar datos para CSV
    const csvData = [];
    
    // Encabezados
    csvData.push(['Sección', 'Nivel', 'Código', 'Nombre', 'Saldo Inicial', 'Cargo Mensual', 'Abono Mensual', 'Saldo Final']);
    
    // Datos
    this.balanceData.activo.forEach(item => {
      csvData.push([
        'ACTIVO',
        item.bg_nivel,
        item.bg_cuenta,
        item.bg_nombre,
        item.bg_saldo_ini,
        '',
        '',
        item.bg_saldo_fin
      ]);
    });
    
    this.balanceData.pasivo.forEach(item => {
      csvData.push([
        'PASIVO',
        item.bg_nivel,
        item.bg_cuenta,
        item.bg_nombre,
        item.bg_saldo_ini,
        '',
        '',
        item.bg_saldo_fin
      ]);
    });
    
    this.balanceData.capital.forEach(item => {
      csvData.push([
        'CAPITAL',
        item.bg_nivel,
        item.bg_cuenta,
        item.bg_nombre,
        item.bg_saldo_ini,
        '',
        '',
        item.bg_saldo_fin
      ]);
    });
    
    // Convertir a string CSV
    const csvString = csvData.map(row => 
      row.map(cell => {
        // Escapar comillas y agregar comillas si contiene comas
        if (typeof cell === 'string' && (cell.includes(',') || cell.includes('"'))) {
          return `"${cell.replace(/"/g, '""')}"`;
        }
        return cell;
      }).join(',')
    ).join('\n');
    
    // Crear y descargar archivo
    const blob = new Blob([csvString], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = `Balance_General_${fecha}.csv`;
    link.click();
  }


  exportAsPDF() {
    console.log('Exportando como PDF para:', this.busqueda);
    // Lógica para exportar el reporte como PDF
      const doc = new jsPDF('landscape', 'pt', 'letter');
    const fecha = new Date().toLocaleDateString('es-MX');
    
    // Título principal
    doc.setFontSize(18);
    doc.setFont('helvetica', 'bold');
    doc.text('BALANCE GENERAL A ' + this.busqueda._year + ' - ' + this.busqueda._month, doc.internal.pageSize.width / 2, 50, { align: 'center' });
    
    // Fecha y datos de empresa (puedes personalizar)
    doc.setFontSize(12);
    doc.setFont('helvetica', 'normal');
    doc.text(`Fecha: ${fecha}`, 40, 80);
    doc.text('Empresa: '+this.empresa_info_actual.titulo, 40, 100);
    doc.text('RFC: '+this.empresa_info_actual.rfc, 40, 120);
    
    // Resumen del balance
    doc.setFontSize(14);
    doc.setFont('helvetica', 'bold');
    doc.text('RESUMEN DEL BALANCE', 40, 150);
    
    doc.setFontSize(12);
    doc.setFont('helvetica', 'normal');
    doc.text(`Segun Estado de Resultados: ${this.formatCurrency(this.balanceData.saldo.saldo)}`, 40, 170);
    doc.text(`Estado: ${this.balanceData.saldo.utilidad ? 'UTILIDAD' : 'PÉRDIDA'}`, 260, 170);
    
    // Tabla de ACTIVO
    this.generarTablaActivo(doc);
    
    // Tabla de PASIVO
    this.generarTablaPasivo(doc);
    
    // Tabla de CAPITAL
    this.generarTablaCapital(doc);
    
    // Ecuación contable
    this.generarEcuacionContable(doc);
    
    // Guardar el PDF
    doc.save(this.empresa_info_actual.titulo.toLowerCase().replace(/\s+/g, '_') + `_balance_general_${fecha.replace(/\//g, '-')}.pdf`);
  }

  private generarTablaActivo(doc: jsPDF) {
    const startY = 200;
    
    // Título de la sección
    doc.setFontSize(16);
    doc.setFont('helvetica', 'bold');
    doc.setTextColor(0, 0, 255); // Azul
    doc.text('ACTIVO', 40, startY);
    
    // Preparar datos para la tabla
    const activoData: any[] = [];
    
    this.groupedActivo.forEach(group => {
      // Fila del grupo principal (nivel 1)
      activoData.push([
        { content: group.parent.bg_cuenta, styles: { fontStyle: 'bold' } },
        { content: group.parent.bg_nombre, styles: { fontStyle: 'bold' } },
        { content: this.formatCurrency(group.parent.bg_cargo_fin - group.parent.bg_abono_fin), styles: { halign: 'right', fontStyle: 'bold' } }
      ]);
      
      // Filas de subcuentas (nivel 2)
      group.children.forEach((item: BalanceItem) => {
        activoData.push([
          `  ${item.bg_cuenta}`,
          `  ${item.bg_nombre}`,
          { content: this.formatCurrency(item.bg_saldo_ini), styles: { halign: 'right' } },
          { content: '', styles: { halign: 'right' } },
          { content: this.formatCurrency(item.bg_saldo_fin), styles: { halign: 'right' } }
        ]);
      });
      
      // Fila de total del grupo
      const totalGrupo = group.children.reduce((total: number, item: BalanceItem) => {
        return total + (item.bg_saldo_fin);
      }, 0);
      
      activoData.push([
        '',
        { content: 'TOTAL ACTIVO', styles: { fontStyle: 'bold' } },
        { content: this.formatCurrency(totalGrupo), styles: { halign: 'right', fontStyle: 'bold' } }
      ]);
    });
    
    // Generar la tabla
    autoTable(doc, {
      startY: startY + 20,
      head: [[
        { content: 'CÓDIGO', styles: { fontStyle: 'bold', fillColor: [173, 216, 230] } },
        { content: 'DESCRIPCIÓN', styles: { fontStyle: 'bold', fillColor: [173, 216, 230] } },
        { content: 'SALDO FINAL', styles: { fontStyle: 'bold', fillColor: [173, 216, 230] } }
      ]],
      body: activoData,
      theme: 'grid',
      styles: {
        fontSize: 10,
        cellPadding: 3,
        overflow: 'linebreak'
      },
      headStyles: {
        fillColor: [41, 128, 185],
        textColor: [255, 255, 255],
        fontStyle: 'bold'
      },
      alternateRowStyles: {
        fillColor: [245, 245, 245]
      },
      columnStyles: {
        0: { cellWidth: 100 },
        1: { cellWidth: 'auto' },
        2: { cellWidth: 100, halign: 'right' },
      },
      margin: { left: 40, right: 40 }
    });
  }

  private generarTablaPasivo(doc: jsPDF) {
    const lastPage = doc.getNumberOfPages();
    const startY = (doc as any).lastAutoTable.finalY + 20;
    
    // Título de la sección
    doc.setFontSize(16);
    doc.setFont('helvetica', 'bold');
    doc.setTextColor(255, 165, 0); // Naranja
    doc.text('PASIVO', 40, startY);
    
    // Preparar datos para la tabla
    const pasivoData: any[] = [];
    
    this.groupedPasivo.forEach(group => {
      // Fila del grupo principal
      pasivoData.push([
        { content: group.parent.bg_cuenta, styles: { fontStyle: 'bold' } },
        { content: group.parent.bg_nombre, styles: { fontStyle: 'bold' } },
        { content: this.formatCurrency(group.parent.bg_cargo_fin - group.parent.bg_abono_fin), styles: { halign: 'right', fontStyle: 'bold' } }
      ]);
      
      // Filas de subcuentas
      group.children.forEach((item: BalanceItem) => {
        pasivoData.push([
          `  ${item.bg_cuenta}`,
          `  ${item.bg_nombre}`,
          { content: this.formatCurrency(item.bg_saldo_fin), styles: { halign: 'right' } }
        ]);
      });
      
      // Total del pasivo
      const totalGrupo = group.children.reduce((total: number, item: BalanceItem) => {
        return total + (item.bg_saldo_fin);
      }, 0);
      
      pasivoData.push([
        '',
        { content: 'TOTAL PASIVO', styles: { fontStyle: 'bold' } },
        { content: this.formatCurrency(totalGrupo), styles: { halign: 'right', fontStyle: 'bold' } }
      ]);
    });
    
    // Generar la tabla
    autoTable(doc, {
      startY: startY + 20,
      head: [[
        { content: 'CÓDIGO', styles: { fontStyle: 'bold', fillColor: [255, 195, 0] } },
        { content: 'DESCRIPCIÓN', styles: { fontStyle: 'bold', fillColor: [255, 195, 0] } },
        { content: 'SALDO FINAL', styles: { fontStyle: 'bold', fillColor: [255, 195, 0] } }
      ]],
      body: pasivoData,
      theme: 'grid',
      styles: {
        fontSize: 10,
        cellPadding: 3
      },
      headStyles: {
        fillColor: [243, 156, 18],
        textColor: [255, 255, 255],
        fontStyle: 'bold'
      },
      alternateRowStyles: {
        fillColor: [255, 248, 220]
      },
      columnStyles: {
        0: { cellWidth: 100 },
        1: { cellWidth: 'auto' },
        2: { cellWidth: 120, halign: 'right' }
      },
      margin: { left: 40, right: 40 }
    });
  }

  private generarTablaCapital(doc: jsPDF) {
    const lastPage = doc.getNumberOfPages();
    const startY = (doc as any).lastAutoTable.finalY + 20 ;
    
    // Título de la sección
    doc.setFontSize(16);
    doc.setFont('helvetica', 'bold');
    doc.setTextColor(0, 128, 0); // Verde
    doc.text('CAPITAL CONTABLE', 40, startY);
    
    // Preparar datos para la tabla
    const capitalData: any[] = [];
    
    this.groupedCapital.forEach(group => {
      // Fila del grupo principal
      capitalData.push([
        { content: group.parent.bg_cuenta, styles: { fontStyle: 'bold' } },
        { content: group.parent.bg_nombre, styles: { fontStyle: 'bold' } },
        { content: this.formatCurrency(group.parent.bg_cargo_fin - group.parent.bg_abono_fin), styles: { halign: 'right', fontStyle: 'bold' } }
      ]);
      
      // Filas de subcuentas
      group.children.forEach((item: BalanceItem) => {
        capitalData.push([
          `  ${item.bg_cuenta}`,
          `  ${item.bg_nombre}`,
          { content: this.formatCurrency(item.bg_saldo_fin), styles: { halign: 'right' } }
        ]);
      });
      
      // Total del capital
      const totalGrupo = group.children.reduce((total: number, item: BalanceItem) => {
        return total + (item.bg_saldo_fin);
      }, 0);
      
      capitalData.push([
        '',
        { content: 'TOTAL CAPITAL', styles: { fontStyle: 'bold' } },
        { content: this.formatCurrency(totalGrupo), styles: { halign: 'right', fontStyle: 'bold' } }
      ]);
    });
    
    // Generar la tabla
    autoTable(doc, {
      startY: startY + 20,
      head: [[
        { content: 'CÓDIGO', styles: { fontStyle: 'bold', fillColor: [144, 238, 144] } },
        { content: 'DESCRIPCIÓN', styles: { fontStyle: 'bold', fillColor: [144, 238, 144] } },
        { content: 'SALDO FINAL', styles: { fontStyle: 'bold', fillColor: [144, 238, 144] } }
      ]],
      body: capitalData,
      theme: 'grid',
      styles: {
        fontSize: 10,
        cellPadding: 3
      },
      headStyles: {
        fillColor: [39, 174, 96],
        textColor: [255, 255, 255],
        fontStyle: 'bold'
      },
      alternateRowStyles: {
        fillColor: [220, 255, 220]
      },
      columnStyles: {
        0: { cellWidth: 100 },
        1: { cellWidth: 'auto' },
        2: { cellWidth: 120, halign: 'right' }
      },
      margin: { left: 40, right: 40 }
    });
  }
getTotalActivo(): number {
    return this.getTotalSaldoFinal(this.balanceData.activo);
  }

  getTotalPasivo(): number {
    return this.getTotalSaldoFinal(this.balanceData.pasivo);
  }

  getTotalCapital(): number {
    return this.getTotalSaldoFinal(this.balanceData.capital);
  }
  private generarEcuacionContable(doc: jsPDF) {
    const lastPage = doc.getNumberOfPages();
    const startY = (doc as any).lastAutoTable.finalY + 30;
    
    doc.setFontSize(14);
    doc.setFont('helvetica', 'bold');
    doc.setTextColor(0, 0, 0);
    doc.text('ECUACIÓN CONTABLE', doc.internal.pageSize.width / 2, startY, { align: 'center' });
    
    doc.setFontSize(12);
    doc.setFont('helvetica', 'normal');
    doc.text('ACTIVO = PASIVO + CAPITAL CONTABLE', doc.internal.pageSize.width / 2, startY + 20, { align: 'center' });
    
    doc.setFont('helvetica', 'bold');
    doc.text(`${this.formatCurrency(this.getTotalActivo())} = ${this.formatCurrency(this.getTotalPasivo())} + ${this.formatCurrency(this.getTotalCapital())}`, 
             doc.internal.pageSize.width / 2, startY + 40, { align: 'center' });
    
    // Verificar la ecuación
    const totalActivo = this.getTotalActivo();
    const totalPasivoCapital = this.getTotalPasivo() + this.getTotalCapital();
    const diferencia = Math.abs(totalActivo - totalPasivoCapital);
    
    if (diferencia < 0.01) {
      doc.setTextColor(0, 128, 0);
      doc.text('ECUACIÓN CONTABLE BALANCEADA', doc.internal.pageSize.width / 2, startY + 60, { align: 'center' });
    } else {
      doc.setTextColor(255, 0, 0);
      doc.text(`DESAJUSTE DE ${this.formatCurrency(diferencia)}`, doc.internal.pageSize.width / 2, startY + 60, { align: 'center' });
    }
    
    // Pie de página
    const pageHeight = doc.internal.pageSize.height;
    doc.setFontSize(10);
    doc.setFont('helvetica', 'italic');
    doc.setTextColor(128, 128, 128);
    doc.text('Documento generado automáticamente por el sistema', doc.internal.pageSize.width / 2, pageHeight - 20, { align: 'center' });
  }

  // Método alternativo para un PDF más compacto
  generarPDFCompacto() {
    const doc = new jsPDF('landscape', 'pt', 'letter');
    const fecha = new Date().toLocaleDateString('es-MX');
    
    // Título
    doc.setFontSize(18);
    doc.setFont('helvetica', 'bold');
    doc.text('BALANCE GENERAL COMPACTO', doc.internal.pageSize.width / 2, 40, { align: 'center' });
    doc.setFontSize(12);
    doc.setFont('helvetica', 'normal');
    doc.text(`Fecha: ${fecha}`, doc.internal.pageSize.width / 2, 60, { align: 'center' });
    
    // Preparar datos combinados
    const tableData: any[] = [];
    
    // Encabezados
    tableData.push([
      { content: 'SECCIÓN', styles: { fontStyle: 'bold', fillColor: [41, 128, 185] } },
      { content: 'CUENTA', styles: { fontStyle: 'bold', fillColor: [41, 128, 185] } },
      { content: 'DESCRIPCIÓN', styles: { fontStyle: 'bold', fillColor: [41, 128, 185] } },
      { content: 'SALDO FINAL', styles: { fontStyle: 'bold', fillColor: [41, 128, 185] } }
    ]);
    
    // ACTIVO
    tableData.push([
      { content: 'ACTIVO', styles: { fontStyle: 'bold', fillColor: [173, 216, 230] } },
      this.balanceData.activo[0].bg_cuenta,
      this.balanceData.activo[0].bg_nombre,
      { content: this.formatCurrency(this.balanceData.activo[0].bg_saldo_fin), 
        styles: { halign: 'right', fontStyle: 'bold' } }
    ]);
    
    this.balanceData.activo.slice(1).forEach(item => {
      tableData.push([
        '',
        item.bg_cuenta,
        item.bg_nombre,
        { content: this.formatCurrency(item.bg_saldo_fin), styles: { halign: 'right' } }
      ]);
    });
    
    // PASIVO
    tableData.push([
      { content: 'PASIVO', styles: { fontStyle: 'bold', fillColor: [255, 195, 0] } },
      this.balanceData.pasivo[0].bg_cuenta,
      this.balanceData.pasivo[0].bg_nombre,
      { content: this.formatCurrency(this.balanceData.pasivo[0].bg_saldo_fin), 
        styles: { halign: 'right', fontStyle: 'bold' } }
    ]);
    
    this.balanceData.pasivo.slice(1).forEach(item => {
      tableData.push([
        '',
        item.bg_cuenta,
        item.bg_nombre,
        { content: this.formatCurrency(item.bg_saldo_fin), styles: { halign: 'right' } }
      ]);
    });
    
    // CAPITAL
    tableData.push([
      { content: 'CAPITAL', styles: { fontStyle: 'bold', fillColor: [144, 238, 144] } },
      this.balanceData.capital[0].bg_cuenta,
      this.balanceData.capital[0].bg_nombre,
      { content: this.formatCurrency(this.balanceData.capital[0].bg_saldo_fin), 
        styles: { halign: 'right', fontStyle: 'bold' } }
    ]);
    
    this.balanceData.capital.slice(1).forEach(item => {
      tableData.push([
        '',
        item.bg_cuenta,
        item.bg_nombre,
        { content: this.formatCurrency(item.bg_saldo_fin), styles: { halign: 'right' } }
      ]);
    });
    
    // Totales
    tableData.push([
      { content: 'TOTAL ACTIVO', styles: { fontStyle: 'bold', fillColor: [200, 230, 255] } },
      '',
      '',
      { content: this.formatCurrency(this.getTotalActivo()), styles: { halign: 'right', fontStyle: 'bold' } }
    ]);
    
    tableData.push([
      { content: 'TOTAL PASIVO', styles: { fontStyle: 'bold', fillColor: [255, 248, 220] } },
      '',
      '',
      { content: this.formatCurrency(this.getTotalPasivo()), styles: { halign: 'right', fontStyle: 'bold' } }
    ]);
    
    tableData.push([
      { content: 'TOTAL CAPITAL', styles: { fontStyle: 'bold', fillColor: [220, 255, 220] } },
      '',
      '',
      { content: this.formatCurrency(this.getTotalCapital()), styles: { halign: 'right', fontStyle: 'bold' } }
    ]);
    
    // Generar tabla
    autoTable(doc, {
      startY: 80,
      body: tableData,
      theme: 'grid',
      styles: {
        fontSize: 10,
        cellPadding: 4,
        overflow: 'linebreak'
      },
      columnStyles: {
        0: { cellWidth: 80, fontStyle: 'bold' },
        1: { cellWidth: 100 },
        2: { cellWidth: 'auto' },
        3: { cellWidth: 120, halign: 'right' }
      },
      margin: { left: 40, right: 40 }
    });
    
    // Guardar
    doc.save(`Balance_Compacto_${fecha.replace(/\//g, '-')}.pdf`);
  }
getTotalSaldoFinal(items: BalanceItem[]): number {
  //Solo necesito obtener el saldo final del registro donde bg_nivel es 1
  const nivel1Item = items.find(item => item.bg_nivel === 1);
  return nivel1Item ? nivel1Item.bg_saldo_fin : 0;
  }

  formatCurrency(value: number): string {
    return new Intl.NumberFormat('es-MX', {
      style: 'currency',
      currency: 'MXN',
      minimumFractionDigits: 2
    }).format(value);
  }
}
interface BalanceItem {
  bg_nivel: number;
  bg_cuenta: string;
  bg_nombre: string;
  bg_saldo_ini: number;
  bg_mov_mens: number;
  bg_saldo_fin: number;
}

interface BalanceData {
  saldo: {
    saldo: number;
    utilidad: boolean;
  };
  activo: BalanceItem[];
  pasivo: BalanceItem[];
  capital: BalanceItem[];
}